var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg013Download(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.12,31.57h-4.89c-.55,0-1,.45-1,1s.45,1,1,1h4.89c1.24,0,2.24,1,2.24,2.24v3.8c0,1.24-1,2.24-2.24,2.24H6.88c-1.24,0-2.24-1.01-2.24-2.24v-3.8c0-1.24,1-2.24,2.24-2.24h4.24c.55,0,1-.45,1-1s-.45-1-1-1h-4.24c-2.34,0-4.24,1.9-4.24,4.24v3.8c0,2.34,1.9,4.24,4.24,4.24h34.24c2.34,0,4.24-1.9,4.24-4.24v-3.8c0-2.34-1.9-4.24-4.24-4.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.85,37.24c.18.22.45.37.76.37s.58-.15.76-.37l13.4-11.82c.41-.37.45-1,.09-1.41-.37-.41-1-.45-1.41-.09l-11.83,10.44V5.15c0-.55-.45-1-1-1s-1,.45-1,1v29.21l-11.83-10.44c-.41-.36-1.04-.33-1.41.09-.37.41-.33,1.05.09,1.41l13.4,11.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.46,38.71c.55,0,1-.45,1-1s-.45-1-1-1h-3c-.55,0-1,.45-1,1s.45,1,1,1h3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg013Download);
export default __webpack_public_path__ + "static/media/013-download.8e5c395bf2b5f9da968d848fe5060376.svg";
export { ForwardRef as ReactComponent };